import { render } from "./LoadingProcess.vue?vue&type=template&id=cc3b6e3c&ts=true"
import script from "./LoadingProcess.vue?vue&type=script&lang=ts"
export * from "./LoadingProcess.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__